/* Yadixo UI layer — motion hooks.
 * Loaded in every layout after yadixo-theme.css. Pure DOM, no framework access:
 *  - Force light mode (no theme toggle).
 *  - Route-change entrance (fade-up on <main>) and list stagger, so screens
 *    "arrive" instead of popping (DESIGN.md §5).
 */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function applyLight() {
    document.body.classList.remove('dark');
    document.documentElement.classList.remove('dark');
    document.documentElement.style.setProperty('color-scheme', 'light');
  }

  function stagger(root) {
    var all = root.querySelectorAll("*"), done = 0;
    for (var n = 0; n < all.length && done < 6; n++) {
      var el = all[n], kids = el.children;
      if (kids.length < 2 || kids.length > 60 || el.classList.contains('yx-stagger')) continue;
      var tag = kids[0].tagName, cls = kids[0].classList[0] || '', ok = true;
      for (var k = 1; k < kids.length && ok; k++) ok = kids[k].tagName === tag && (kids[k].classList[0] || '') === cls;
      if (!ok || tag === 'OPTION' || tag === 'SPAN' || tag === 'SVG' || tag === 'PATH') continue;
      for (var h = 0; h < kids.length && ok; h++) ok = kids[h].getBoundingClientRect().height <= 160;
      if (!ok) continue;
      for (var i = 0; i < kids.length && i < 8; i++) {
        kids[i].style.setProperty('--yx-i', i);
        kids[i].classList.add('yx-stagger');
      }
      done++;
      n += kids.length;
    }
  }
  var watcher = null, watchTimer = null, staggerTimer = null;
  function watchFor(main, ms) {
    if (watcher) watcher.disconnect();
    watcher = new MutationObserver(function () {
      clearTimeout(staggerTimer);
      staggerTimer = setTimeout(function () { stagger(main); }, 60);
    });
    watcher.observe(main, { childList: true, subtree: true });
    clearTimeout(watchTimer);
    watchTimer = setTimeout(function () { watcher.disconnect(); watcher = null; }, ms);
  }
  function enter() {
    if (reduce) return;
    var main = document.querySelector('main');
    if (!main) { setTimeout(enter, 120); return; }
    main.classList.remove('yx-enter');
    void main.offsetWidth;
    main.classList.add('yx-enter');
    stagger(main);
    watchFor(main, 2500);
  }
  function hookRouter() {
    var push = history.pushState, replace = history.replaceState;
    history.pushState = function () { var r = push.apply(this, arguments); enter(); return r; };
    history.replaceState = function () { var r = replace.apply(this, arguments); return r; };
    window.addEventListener('popstate', enter);
  }

  function init() {
    applyLight();
    hookRouter();
    enter();
    var aside = document.querySelector('aside');
    if (aside && !reduce) setTimeout(function () { stagger(aside); }, 200);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
